import { addDays, addMonths, type TenantSettings } from '@dairy/shared';

/** D-4 breeding dates. */

export function expectedCalving(serviceDate: string, s: Pick<TenantSettings, 'gestationDays'>): string {
  return addDays(serviceDate, s.gestationDays);
}

export function dryOffDue(expectedCalvingDate: string, s: Pick<TenantSettings, 'dryPeriodDays'>): string {
  return addDays(expectedCalvingDate, -s.dryPeriodDays);
}

export function heatWatchWindow(
  serviceDate: string,
  s: Pick<TenantSettings, 'heatWatchStartDays' | 'heatWatchEndDays'>,
): { start: string; end: string } {
  return { start: addDays(serviceDate, s.heatWatchStartDays), end: addDays(serviceDate, s.heatWatchEndDays) };
}

export function pregCheckDue(serviceDate: string, s: Pick<TenantSettings, 'pregCheckDays'>): string {
  return addDays(serviceDate, s.pregCheckDays);
}

export function breedingStartDue(calvingDate: string, s: Pick<TenantSettings, 'breedingStartDays'>): string {
  return addDays(calvingDate, s.breedingStartDays);
}

export function heiferBreedingDue(birthDate: string, s: Pick<TenantSettings, 'heiferBreedingAgeMonths'>): string {
  return addMonths(birthDate, s.heiferBreedingAgeMonths);
}

/** D-5: the calving reminder is due 14 days before the expected calving. */
export const CALVING_REMINDER_LEAD_DAYS = 14;
export function calvingReminderDue(expectedCalvingDate: string): string {
  return addDays(expectedCalvingDate, -CALVING_REMINDER_LEAD_DAYS);
}
